<!-- eslint-disable max-len -->
<template>
  <svg width="14px"
       height="14px"
       viewBox="0 0 14 14"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
       :style="{ color: baseColor || 'currentColor' }">
    <path d="M4.74364 10.6301C4.4997 10.0837 4.07281 9.59803 3.46296 9.3552L0.291748 8.08031L3.52395 6.74472C4.07281 6.50188 4.56069 6.07692 4.80463 5.46983L6.14629 2.25226L7.48796 5.46983C7.7319 6.01621 8.15879 6.50188 8.76864 6.74472L12.0008 8.08031L8.76864 9.41591C8.21978 9.65874 7.7319 10.0837 7.48796 10.6908L6.14629 13.9084L4.74364 10.6301ZM9.62243 2.79864L8.21978 3.2236L9.62243 3.64856C10.0493 3.76998 10.4152 4.13423 10.5372 4.5592L10.9641 5.9555L11.391 4.5592C11.513 4.13423 11.8789 3.76998 12.3058 3.64856L13.7084 3.2236L12.3058 2.79864C11.8789 2.67722 11.513 2.31297 11.391 1.888L10.9641 0.491699L10.5372 1.888C10.4152 2.31297 10.0493 2.67722 9.62243 2.79864Z" fill="#0074B9" />
  </svg>
</template>

<script>
export default {
    props: {
        baseColor: {
            type: String
        }
    }
};
</script>